@if (display$ | async) {
  <app-icon icon="print" [beatFade]="true" i18n-matTooltip matTooltip="Your documents are being prepared..."></app-icon>
}
